import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let TrafficType = class TrafficType extends VuexModule {
    retrogradeMapData = new Map();
    allCompleted = false;
    updataRetrogradeData(data) {
    }
    updataAllCompleted(data) {
        this.allCompleted = data;
    }
};
__decorate([
    Mutation
], TrafficType.prototype, "updataRetrogradeData", null);
__decorate([
    Mutation
], TrafficType.prototype, "updataAllCompleted", null);
TrafficType = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/TrafficType' })
], TrafficType);
export const TrafficTypeModule = getModule(TrafficType);
